import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User opens edit mode for a transcript',
  name: 'transcription_edit_mode',
};

export default META;
